import React from 'react';
import ConfettiAnimation from './ConfettiAnimation';

const OnboardingCompletionModal = ({ isOpen, onClose, onStartPhase2 }) => {
  if (!isOpen) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  };

  const contentStyle = {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: window.innerWidth < 768 ? '32px 24px' : '48px',
    maxWidth: '600px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
    animation: 'slideUp 0.5s ease-out',
  };

  const titleStyle = {
    fontSize: window.innerWidth < 768 ? '28px' : '36px',
    fontWeight: '700',
    color: '#003366',
    marginBottom: '12px',
    marginTop: '0',
  };

  const emojiStyle = {
    fontSize: '80px',
    marginBottom: '20px',
    display: 'block',
    animation: 'bounce 1s ease-in-out 3',
  };

  const subtitleStyle = {
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    color: '#666',
    marginBottom: '20px',
    lineHeight: '1.6',
  };

  const progressStyle = {
    backgroundColor: '#f0f7ff',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '30px',
    border: '2px solid #007bff',
  };

  const bulletStyle = {
    textAlign: 'left',
    fontSize: window.innerWidth < 768 ? '14px' : '15px',
    color: '#333',
    margin: '12px 0',
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '12px',
    flexDirection: window.innerWidth < 768 ? 'column' : 'row',
    justifyContent: 'center',
    marginTop: '30px',
  };

  const primaryButtonStyle = {
    flex: window.innerWidth < 768 ? '1' : '0',
    padding: window.innerWidth < 768 ? '14px 16px' : '14px 32px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };

  const secondaryButtonStyle = {
    flex: window.innerWidth < 768 ? '1' : '0',
    padding: window.innerWidth < 768 ? '14px 16px' : '14px 32px',
    backgroundColor: 'transparent',
    color: '#007bff',
    border: '2px solid #007bff',
    borderRadius: '8px',
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <ConfettiAnimation isActive={isOpen} duration={3000} />

      <div style={contentStyle} onClick={(e) => e.stopPropagation()}>
        <span style={emojiStyle}>🎉</span>

        <h2 style={titleStyle}>Congratulations!</h2>

        <p style={subtitleStyle}>
          You've completed the SwiftBidPro setup! You're now ready to start managing your quotes and clients.
        </p>

        <div style={progressStyle}>
          <h4 style={{ margin: '0 0 16px 0', color: '#007bff', fontSize: '16px', fontWeight: '600' }}>
            ✓ Setup Completed
          </h4>
          <div style={bulletStyle}>
            ✓ Settings customized
          </div>
          <div style={bulletStyle}>
            ✓ Client created
          </div>
          <div style={bulletStyle}>
            ✓ Quote drafted
          </div>
          <div style={bulletStyle}>
            ✓ Quote sent
          </div>
          <div style={bulletStyle}>
            ✓ Ready to grow your business
          </div>
        </div>

        <p style={{ ...subtitleStyle, marginBottom: '0', color: '#555' }}>
          Want to unlock more powerful features? Let's explore Phase 2 of your setup.
        </p>

        <div style={buttonContainerStyle}>
          <button
            style={secondaryButtonStyle}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f0f7ff';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            Explore Later
          </button>
          <button
            style={primaryButtonStyle}
            onClick={onStartPhase2}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#0056b3';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 16px rgba(0, 91, 179, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#007bff';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Start Phase 2
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
};

export default OnboardingCompletionModal;
